import Select from "@material-ui/core/Select";
import { availableLanguages, fontName } from "../../../constants/utils";
import { css } from "@emotion/css";
import MenuItem from "@material-ui/core/MenuItem";
import Icon from "@material-ui/core/Icon";
import LanguageIcon from "@material-ui/icons/Language";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LanguageSwitcherStyle from "./languageSwitcherStyle";
import { useDispatch, useSelector } from "react-redux";
import { changeLanguage } from "../../../store/actions/menu";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles(LanguageSwitcherStyle);

const OnboardingLanguageSwitcher = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuInfo = useSelector((state) => state.menuInfo);
  const { menuData, languages, selected_language } = menuInfo;
  const { theme_data, enable_language_onboarding, license } = menuData;

  const handleLanguageSelection = (e) => {
    const langCode = e.target.value;
    const segments = location.pathname.split("/").filter(Boolean);
    const validLangs = availableLanguages.map((lang) => lang.code);
    let subPathSegments = segments;

    // If the first segment is a valid lang code, that means
    // we do have a language prefix in the URL
    if (validLangs.includes(segments[0])) {
      subPathSegments = segments.slice(1);
      // e.g. ["product", "123"]
    }
    const newPath = `/${langCode}/${subPathSegments.join("/")}`;
    dispatch(changeLanguage(license, langCode));
    history.push(newPath);
  };

  return (
    <div className={classes.languageSelectorContainer}>
      {languages.length > 1 && enable_language_onboarding ? (
        <div className={classes.languageSelector}>
          <Select
            value={selected_language}
            onChange={handleLanguageSelection}
            inputProps={{
              name: "lang",
            }}
            style={{
              color: theme_data?.onboarding_screen_language_dropdown_text_color,
              fontSize: Number(
                theme_data?.onboarding_screen_language_dropdown_font_size
              ),
              ...fontName(
                theme_data?.onboarding_screen_language_dropdown_font_family
              ),
            }}
            className={css`
              &::after,
              &::before {
                border-bottom-color: ${theme_data?.onboarding_screen_icon_color};
              }
            `}
          >
            {menuInfo.languages.map((x, i) => (
              <MenuItem key={i} value={x.code}>
                {x.name_local}
              </MenuItem>
            ))}
          </Select>

          <Icon style={{ color: theme_data?.onboarding_screen_icon_color }}>
            <LanguageIcon />
          </Icon>
        </div>
      ) : null}
    </div>
  );
};

export default OnboardingLanguageSwitcher;
